import React from "react";
import "./Pagination.scss";

interface PaginationProps {
  current: number;
  total: number;
  pageSize?: number;
  onChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ current, total, pageSize = 10, onChange }) => {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const pages: (number | "...")[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (current > 3) pages.push("...");
    for (let i = Math.max(2, current - 1); i <= Math.min(totalPages - 1, current + 1); i++) {
      pages.push(i);
    }
    if (current < totalPages - 2) pages.push("...");
    pages.push(totalPages);
  }

  return (
    <div className="pagination">
      <button className="pagination__btn" disabled={current === 1} onClick={() => onChange(current - 1)}>
        ‹
      </button>
      {pages.map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} className="pagination__ellipsis">
            …
          </span>
        ) : (
          <button key={p} className={`pagination__btn ${p === current ? "pagination__btn--active" : ""}`} onClick={() => onChange(p as number)}>
            {p}
          </button>
        ),
      )}
      <button className="pagination__btn" disabled={current === totalPages} onClick={() => onChange(current + 1)}>
        ›
      </button>
      <span className="pagination__info">총 {total}개</span>
    </div>
  );
};

export default Pagination;
